// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './BlogPage.style';
import Link from '@scandipwa/scandipwa/src/component/Link';
import ReadmoreIcon from 'Component/ReadmoreIcon';

export class BlogPage extends PureComponent {
    static propTypes = {
        device: this.propTypes,
        blogPosts: this.propTypes
    };

    renderBlog(value, index) {
        var date = new Date(value?.publish_time);

        return (
            <div className='BlogPage-Blog' key={index}>
                <Link to={`/blog/post?post_id=${value?.post_id}`}>
                    <div className='BlogPage-BlogLink'>
                        <div className='BlogPage-BlogImage'>
                            <img src={value?.featured_image} />
                        </div>
                        <div className='BlogPage-BlogContenet'>
                            <span className='BlogPage-BlogDate'>{date.toDateString()}</span>
                            <h3>{value?.title}</h3>
                            <div className='BlogLink-ReadMore'>
                                <span>read more</span>
                                <ReadmoreIcon />
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }

    renderFirstBlog(firstblog) {
        firstblog = firstblog?.slice(0, 1);

        return (
            <div className='BlogPage-Gallery'>
                {
                    firstblog?.map((value, index) => (
                        <div className='BlogPage-FirstBlog' key={index}>
                            <Link to={`/blog/post?post_id=${value?.post_id}`}>
                                <div className='BlogPage-BlogLink'>
                                    <div className='BlogPage-BlogImage'>
                                        <img src={value?.featured_image} />
                                    </div>
                                    <div className='BlogPage-BlogContenet'>
                                        <span className='BlogPage-BlogDate'>{new Date(value?.publish_time).toDateString()}</span>
                                        <h3>{value?.title}</h3>
                                        <div className='Blogs-Description' dangerouslySetInnerHTML={{ __html: value?.short_filtered_content.slice(0, 500) }}></div>
                                        <div className='BlogLink-ReadMore'>
                                            <span>read more</span>
                                            <ReadmoreIcon />
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))
                }
            </div>
        )
    }

    renderBlogGallery(items) {
        items = items?.slice(1);

        return (
            <div className='BlogPage-Gallery'>
                <div className='BlogPage-Gallery-Content'>
                    {
                        items?.map((value, index) => (
                            this.renderBlog(value, index)
                        ))
                    }
                </div>
            </div>
        )
    }

    render() {
        const { blogPosts: { items } } = this.props;

        return (
            <div className="BlogPage">
                <div className='BlogPage-Heading'>
                    <h1>my blog</h1>
                </div>
                {/* <div className='BlogPage-Title'>
                    <span>popular blogs</span>
                </div> */}
                {this.renderFirstBlog(items)}
                {this.renderBlogGallery(items)}
            </div>
        );
    }
}

export default BlogPage;
